export enum SelectStatementType {
  ALL = 'ALL',
  COUNT = 'COUNT',
  ATTRITION = 'ATTRITION',
}

export type CohortTranslation = {
  sqlQuery: string;
  selectStmtType: SelectStatementType;
};
